// Tutorial 2: Analytics Overview
// Shown to admins after Tutorial 1

export const TUTORIAL_KEY = 'analytics_intro';

export const steps = [
  {
    id: 'intro',
    title: 'Analytics: Your Salesforce Data',
    icon: '📊',
    content: 'We sync your Salesforce data to our analytics engine. This lets you:',
    bullets: [
      'Query data with SQL (faster than SF reports)',
      'Build custom visualizations',
      'Create dashboards your team can use',
    ],
  },
  {
    id: 'sync',
    title: 'Configuring Sync',
    icon: '⚙️',
    content: 'Choose which Salesforce objects to sync:',
    bullets: [
      'Accounts, Contacts, Opportunities',
      'Custom objects',
      'Select specific fields to include',
    ],
  },
  {
    id: 'views',
    title: 'Views',
    icon: '📋',
    content: "Views are saved queries. Write once, reuse everywhere. We use FrankenQL - a hybrid of SOQL and SQL. If you don't know either, hire us!",
    bullets: [
      'SOQL-style object references (Account, Contact)',
      'SQL-style aggregations and joins',
      'Views power your visualizations',
    ],
  },
  {
    id: 'visualizations',
    title: 'Visualizations',
    icon: '📈',
    content: 'Turn your views into charts with Plotly.js:',
    bullets: [
      'Bar charts, pie charts, funnels',
      'Tables with formatting',
      'KPI indicators',
    ],
  },
  {
    id: 'vizLifecycle',
    title: 'Managing Visualizations',
    icon: '🔄',
    content: "Don't start from scratch! You can:",
    bullets: [
      'Use the Reference Library for pre-built views and visualizations',
      'Clone any visualization to customize it',
      "Export/import to migrate between tenants (or share with others)",
      "Don't know Plotly? Hire us!",
    ],
  },
  {
    id: 'done',
    title: 'Analytics Ready',
    icon: '✅',
    content: 'Head to the Analytics tab to configure your first sync, enable the Reference Library, and create your own views.',
  },
];

export default { TUTORIAL_KEY, steps };
